import axios from 'axios';
axios.defaults.baseURL = 'https://raw.githubusercontent.com/flamez100598';
 export default axios;